/**
 * SwatchGrid — 5-swatch mosaic: 1 large left + 2×2 right.
 * Placeholder for real recipe thumbnails (v1 uses flat color swatches).
 *
 * Dynamic pack colors set `--rp-swatch-bg` per cell (only necessary inline style).
 * Height uses design tokens via `size` (see --rp-swatch-grid-h-* in design-tokens.css).
 */
const SIZE_CLASS = {
  xs: 'rp-swatch-grid--h-xs',
  sm: 'rp-swatch-grid--h-sm',
  md: 'rp-swatch-grid--h-md',
  'md-plus': 'rp-swatch-grid--h-md-plus',
  lg: 'rp-swatch-grid--h-lg',
  xl: 'rp-swatch-grid--h-xl',
  '2xl': 'rp-swatch-grid--h-2xl',
}

function SwatchCell({ color, className }) {
  return (
    <div
      className={className}
      style={color ? { '--rp-swatch-bg': color } : undefined}
    />
  )
}

export default function SwatchGrid({ swatches, size = 'sm' }) {
  const heightClass = SIZE_CLASS[size] || SIZE_CLASS.sm
  const cells = swatches || []

  return (
    <div className={`rp-swatch-grid ${heightClass}`}>
      <SwatchCell color={cells[0]} className="rp-swatch-grid-cell rp-swatch-grid-cell--hero" />
      <SwatchCell color={cells[1]} className="rp-swatch-grid-cell" />
      <SwatchCell color={cells[2]} className="rp-swatch-grid-cell" />
      <SwatchCell color={cells[3]} className="rp-swatch-grid-cell" />
      <SwatchCell color={cells[4]} className="rp-swatch-grid-cell" />
    </div>
  )
}
